import React, { useEffect, useState } from 'react';
import api from '../../services/api';

export default function AgendaSyncStatus() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get('/settings/last_sync');
        if (alive) setInfo(data.value ? JSON.parse(data.value) : null);
      } catch {
        // The status is informational; it must not block Agenda.
      }
    };
    load();
    const timer = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  if (!info?.at) return null;
  const minutes = Math.max(0, Math.round((Date.now() - new Date(info.at).getTime()) / 60000));
  const age = minutes < 1 ? 'recién' : minutes < 60 ? `hace ${minutes} min` : `hace ${Math.round(minutes / 60)} h`;

  return (
    <p className={`ag-sync-status${info.ok ? '' : ' ag-sync-status--error'}`} title={info.error || ''}>
      {info.ok ? `Sincronizado ${age}` : `⚠ Error de sync ${age}`}
    </p>
  );
}
